export default "__VITE_ASSET__6ede4882__"